module.exports = __webpack_public_path__ + "static/media/chess-2.5939b107.png";